import { UnsupportedActionException } from '@amzn/ihm-associate-tools-js-lib'
import { AuthenticatedRequestHandler } from '@api/utils/AuthenticatedRequestHandler'

/**
 * Listens for AuthenticatedRequestHandler requests and forwards them to AuthenticatedRequestHandler.
 * Returns a promise from the AuthenticatedRequestHandler.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - raw
 *          parameters: {object} - object containing the parameters for the specific action
 *      }
 *  }
 * @return {Promise} - Promise for the specified action.
 */
export async function authenticatedRequestListener (message: any) {
    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters

    switch (action) {
    case 'raw':
        return AuthenticatedRequestHandler.raw(params)
    }

    return Promise.reject(new UnsupportedActionException({
        message: 'Unsupported action: ' + action,
    }))
}
